
export default {
  __name__: 'English',
  // Main page
  registration_deadline_: 'Registration Deadline',
  qualification_: 'Qualification',
  online_jeopardy: 'Online Jeopardy',
  final_: 'Final',
  prizes_: 'Prizes',
  event_organizer_: 'Event Organizer',
  about_: 'About',
  news_: 'News',
  challenge_: 'Challenge',
  rank_main_title_: 'Rank',
  trend_main_title_: 'Trend',
  news_main_title_: '',
  rank_table_: 'Rank',
  trend_: 'Trend',
  scoreboard_: 'Scoreboard',
  countdown_: 'Countdown',
  myTeam_: 'My Team',
  login_: 'Login',
  profile_: 'Profile',
  changePwd_: 'Change Password',
  logout_: 'Logout',
  // About page
  competitionInfo_: 'Competition Information',
  competitionTime_: 'Competition Time',
  contact_: 'Contact',
  prize_: 'Prize',
  categories_: 'Challenge Categories',
  rules_: 'Contest Rules',
  organizer_: 'Organizer',
  sponsors_: 'Sponsors',
  media_: 'Media',
  // Profile page
  location_: 'Location',
  email_: 'Email',
  solvedChallenges_: 'Solved Challenges',
  name_: 'Name',
  score_: 'Score',
  time_: 'Time',
  rank_: 'Rank',
  solved_: 'Solved',
  total_: 'Total',
  inputToken_: 'Input the token to join a team',
  join_: 'Join',
  or_: 'Or',
  createTeam_: 'click here to create a team',
  team_: 'Team',
  player_: 'Player',
  userId_: 'User ID',
  // Challenge info page
  teamSolved_: 'Your team has solved this challenge',
  ctfOver_: 'The CTF is over.',
  teamSolvedCount_: 'Solved by {{totalSolved}} Teams',
  userSolvedCount_: 'Solved by {{totalSolved}} Players',
  solvedSuccessfully_: 'Solved Successfully',
  errParam_: 'Invalid flag',
  errNoLogin_: 'Please login first',
  errGameOver_: 'Submit time is over',
  errWrongFLag_: 'Wrong flag',
  // Challenge page
  challenges_: 'Challenges',
  topTeams_: 'Top Players',
  // Create team page
  createYourTeam_: 'Create Your Team',
  teamName_: 'Team name',
  submit_: 'Submit',
  reset_: 'Reset',
  changeLogo_: 'You can change your team logo later in the team page',
  // Change password page
  password_: 'Password',
  newPwd_: 'New Password',
  retypePwd_: 'Retype New Password',
  notMatch_: 'New password does not match.',
  // Login page
  username_: 'Username',
  register_: 'Register',
  forgetPwd_: 'Forgot Password?',
  // Register page
  registerUser_: 'Register User(not team)',
  clickToLogin_: 'Click here to login',
  invalidUsername_: 'Invalid Username!',
  invalidEmail_: 'Invalid !',
  fillAll_: 'Please fill all fields!',
  // News page
  postedOn_: 'Posted on',
  // Team page
  teamMembers_: 'Team Members',
  teamToken_: 'Team Token',
  clickToUpload_: 'Click logo picture to upload team logo',
  solvedBy_: 'Solved by',
  hacker_: 'Hacker',
  // Trend page
  finishedTime_: 'Finished Time',
  trendBoard_: 'Trend Board',
  // Countdown page
  timeLeft_: 'Time left',
  gameOver_: 'Game Over',
  days_: 'days'
}



// WEBPACK FOOTER //
// ./src/i18n/en-us.js